import { createWithEqualityFn } from 'zustand/traditional'

export interface SearchStore {
    searchValue: string

    setSearchValue: (value: string) => void
}

export const useSearchStore = createWithEqualityFn<SearchStore>()((set) => ({
    searchValue: '',

    setSearchValue: (value: string) => set({ searchValue: value }),
}))
